module.exports = __webpack_public_path__ + "static/media/chubbCheck.6240b5e5.svg";